function getStrParams(data) {
  const keys = Object.keys(data)
  let strParams = ""
  let i = 0
  while(i < keys.length) {
    strParams += `&${keys[i]}=${data[keys[i]]}`
    i++
  }
  return strParams.replace(/^\&/, '')
}
function urlResult(type, url, data) {
  if (type.toLowerCase() === "get") {
    const str = getStrParams(data)
    const params = url.indexOf("?") > -1 ? `&${str}` : `?${str}`
    return (url + params).replace(/\?$/, '')
  }
  return url
}
function ajax({ url = "", type = "get", async = true, data = {} }) {
  return new Promise((response, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.onreadystatechange = function() {
      const text = xhr.responseText
      if(xhr.readyState === 4) {
        if(xhr.status === 200) {
          response(JSON.parse(text).data)
        } else {
          const data = JSON.parse(text)
          reject(data)
        }
      }
    }
    xhr.onerror = function() {
      console.log(xhr);
    }
    type = type.toLowerCase()
    const URL = urlResult(type, url, data)
    xhr.open(type, URL, async)
    type === "get" ? xhr.send() : xhr.send(JSON.stringify(data))
  })
}
export default ajax